export const DRAWING_VIEW_TYPES = {
  FRONT: "front",
  BACK: "back",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top",
  ISO: "iso",
  SECTION: "section",
};

export const DRAWING_VIEW_MODES = {
  HIDDEN_LINE: "hiddenLine",
  WIREFRAME: "wireframe",
  REALISTIC: "realistic",
  XRAY: "xray",
};

export function createDrawingView({
  id,
  name,
  type = DRAWING_VIEW_TYPES.FRONT,
  viewMode = DRAWING_VIEW_MODES.HIDDEN_LINE,
  cameraType = "orthographic",
  scale = 20,
  sectionPlane = null,
} = {}) {
  return {
  id: id || `view_${Date.now()}`,
  name: name || "View",
  type,
  cameraType,
  viewMode,
  scale,
  sectionPlane,

  camera: null,

  projection: {
  originWorld: { x: 0, y: 0, z: 0 },
},

  cropBox: {
    enabled: false,
    x: 0,
    y: 0,
    width: null,
    height: null,
  },

  filters: {
    showGrid: false,
    showGizmo: false,
    showCoordinateSystems: false,
    showMountingDrillings: false,
  },

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
}

export function createSectionView({
  id,
  name = "Section A-A",
  sourceViewId = "view_top",
  label = "A-A",
  start = { x: -500, z: 0 },
  end = { x: 500, z: 0 },
  axis = "z",
  value = 0,
  direction = "front",
  depth = 1000,
  scale = 20,
  angleDeg = 0,
} = {}) {
  return createDrawingView({
    id: id || `section_${Date.now()}`,
    name,
    type: DRAWING_VIEW_TYPES.SECTION,
    cameraType: "orthographic",
    viewMode: DRAWING_VIEW_MODES.HIDDEN_LINE,
    scale,
    sectionPlane: {
      sourceViewId,
      markerId: `marker_${Date.now()}`,
      label,
      start,
      end,
      axis,
      value,
      direction,
      depth,
      angleDeg,
    },
  });
}